(() => {
  if (window.BtrSliderInitialized) return;
  window.BtrSliderInitialized = true;

  const isDesignMode = !!(window.Shopify && window.Shopify.designMode);
  const wrapperSelector = "[data-btr-slider-wrapper]";
  const slideSelectors = [
    "section.btr-section[data-btr-slider-group]"
  ];

  const escapeSelector = (value) => {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    return value.replace(/"/g, '\\"');
  };

  const initGroup = (wrapper) => {
    if (isDesignMode) return;
    const group = wrapper.getAttribute("data-btr-slider-group");
    if (!group) return;

    const swiperEl = wrapper.querySelector(".bls__swiper");
    const swiperWrapper = swiperEl?.querySelector(".swiper-wrapper");
    if (!swiperEl || !swiperWrapper) return;

    const groupSelector = `[data-btr-slider-group=\"${escapeSelector(group)}\"]`;
    const slides = Array.from(
      document.querySelectorAll(slideSelectors.map((selector) => `${selector}${groupSelector}`).join(", "))
    );

    slides.forEach((sectionEl) => {
      const slideHost = sectionEl.closest(".shopify-section") || sectionEl;
      slideHost.classList.add("swiper-slide", "btr-slider-slide");
      if (slideHost.closest(".swiper-wrapper") !== swiperWrapper) {
        swiperWrapper.appendChild(slideHost);
      }
    });

    if (swiperEl.classList.contains("swiper-initialized") && swiperEl.swiper) {
      swiperEl.swiper.update();
      return;
    }

    if (window.BlsSettingsSwiper && typeof window.BlsSettingsSwiper.BlsCarousel === "function") {
      window.BlsSettingsSwiper.BlsCarousel(swiperEl);
    }
  };

  const init = () => {
    document.querySelectorAll(wrapperSelector).forEach(initGroup);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);
  document.addEventListener("shopify:section:unload", init);
})();
